import "./CardTurismoLex.css";
import assetsRoute from "../../../../utilities/assetsRoute";

const CardTurismoLex = (props) => {
  const data = props.data;
  const key = props.key ? props.key : 1;

  const {
    titulo,
    pais,
    subtema,
    resumen,
    regYearPublication,
    regLinkDocument,
    regLinkServer,
    regId,
    codPais,
    enteRegulador,
    codDivAdminist,
  } = data;

  const LinkDownload = regLinkServer ? regLinkServer : regLinkDocument;

  const htmlLang = document.documentElement.lang;
  const isLangEnUS = htmlLang === "en-US";

  const finalLink = isLangEnUS
    ? `${environment.DOMAIN}/en/turismo-lex/regulaciones/${regId}`
    : `${environment.DOMAIN}/turismo-lex/regulaciones/${regId}`;

  return (
    <a
      href={finalLink}
      className="data-card"
      key={key}
    >
      <span className="data-card__year">{regYearPublication}</span>
      <h4 className="data-card__title">{titulo}</h4>
      <p className="data-card__des">{resumen}</p>
      <div className="data-card__country">
        {codPais.map((element, index) => {
          if (element !== null) {
            const nombrePais = pais[index];
            return (
              <div key={index}>
                <img
                  className="block-dr__flag"
                  src={assetsRoute(element.toLowerCase(), "flags", ".svg")}
                  alt={`Bandera de ${nombrePais}`}
                />
                <span>{nombrePais}</span>
              </div>
            );
          }
        })}
      </div>
      <div className="data-card__info">
        <span className="data-card__entidad">{subtema}</span>
        <div className="data-card__downloads">
          <span className="data-card__anchor-donwload">
            <a href={finalLink}>
              Ver
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.0001 8.25C11.0055 8.25 10.0517 8.64509 9.34841 9.34835C8.64515 10.0516 8.25006 11.0054 8.25006 12C8.25006 12.9946 8.64515 13.9484 9.34841 14.6517C10.0517 15.3549 11.0055 15.75 12.0001 15.75C12.9946 15.75 13.9485 15.3549 14.6517 14.6517C15.355 13.9484 15.7501 12.9946 15.7501 12C15.7501 11.0054 15.355 10.0516 14.6517 9.34835C13.9485 8.64509 12.9946 8.25 12.0001 8.25ZM9.75006 12C9.75006 11.4033 9.98711 10.831 10.4091 10.409C10.831 9.98705 11.4033 9.75 12.0001 9.75C12.5968 9.75 13.1691 9.98705 13.5911 10.409C14.013 10.831 14.2501 11.4033 14.2501 12C14.2501 12.5967 14.013 13.169 13.5911 13.591C13.1691 14.0129 12.5968 14.25 12.0001 14.25C11.4033 14.25 10.831 14.0129 10.4091 13.591C9.98711 13.169 9.75006 12.5967 9.75006 12Z"
                  fill="#4D4D4D"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12.0001 3.25C7.48606 3.25 4.44506 5.954 2.68006 8.247L2.64906 8.288C2.24906 8.807 1.88206 9.284 1.63306 9.848C1.36606 10.453 1.25006 11.112 1.25006 12C1.25006 12.888 1.36606 13.547 1.63306 14.152C1.88306 14.716 2.25006 15.194 2.64906 15.712L2.68106 15.753C4.44506 18.046 7.48606 20.75 12.0001 20.75C16.5141 20.75 19.5551 18.046 21.3201 15.753L21.3511 15.712C21.7511 15.194 22.1181 14.716 22.3671 14.152C22.6341 13.547 22.7501 12.888 22.7501 12C22.7501 11.112 22.6341 10.453 22.3671 9.848C22.1171 9.284 21.7501 8.807 21.3511 8.288L21.3191 8.247C19.5551 5.954 16.5141 3.25 12.0001 3.25ZM3.87006 9.162C5.49806 7.045 8.15006 4.75 12.0001 4.75C15.8501 4.75 18.5011 7.045 20.1301 9.162C20.5701 9.732 20.8261 10.072 20.9951 10.454C21.1531 10.812 21.2501 11.249 21.2501 12C21.2501 12.751 21.1531 13.188 20.9951 13.546C20.8261 13.928 20.5691 14.268 20.1311 14.838C18.5001 16.955 15.8501 19.25 12.0001 19.25C8.15006 19.25 5.49906 16.955 3.87006 14.838C3.43006 14.268 3.17406 13.928 3.00506 13.546C2.84706 13.188 2.75006 12.751 2.75006 12C2.75006 11.249 2.84706 10.812 3.00506 10.454C3.17406 10.072 3.43206 9.732 3.87006 9.162Z"
                  fill="#4D4D4D"
                />
              </svg>
            </a>
          </span>
          <span className="data-card__asnchor-donwload">
            <a href={LinkDownload} download target="_blank">
              Descargar
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5001 9V9.5H15.0001H17.793L12.0001 15.2929L6.20717 9.5H9.00006H9.50006V9V3.5H14.5001V9ZM18.5001 19.5H5.50006V18.5H18.5001V19.5Z"
                  stroke="#4D4D4D"
                />
              </svg>
            </a>
          </span>
        </div>
      </div>
    </a>
  );
};

export default CardTurismoLex;
